<div class="asCard ion-color-grey-100">
  <mable-heading
    [heading]="headingType"
    headingStyle="h4"
    class="no-margin ion-no-padding"
    >{{ heading }}</mable-heading
  >
  <ion-item-group>
    <ion-item
      class="ion-no-padding"
      (click)="mailOrCall('mailto:info@mable.com.au')"
      detail="true"
      detail-icon="chevron-forward"
      lines="full"
      color="grey-100"
      button
    >
      <ion-label> Email </ion-label>
      <ion-icon
        name="mail"
        slot="start"
      ></ion-icon>
    </ion-item>
    <ion-item
      class="ion-no-padding"
      (click)="mailOrCall('tel:+611300736573')"
      detail="true"
      detail-icon="chevron-forward"
      lines="none"
      color="grey-100"
      button
    >
      <ion-label> Call </ion-label>
      <ion-icon
        name="call"
        slot="start"
      ></ion-icon>
    </ion-item>
  </ion-item-group>
</div>
